
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart",
      function () {
        return require("private-next-pages/cart.tsx");
      }
    ]);
  